const selectors = {
    THUMB: '.lightbox-thumb',
    MODAL: '#lb-modal',
    MODAL_IMG: '#lb-current-image',
    IMG_WRAP: '#lb-current-image-wrapper',
    CAPTION: '#lb-caption',
    PREV: '.lb-prev',
    NEXT: '.lb-next',
    CLOSE: '.lb-close',
    THUMBS_CONTAINER: '#lb-thumbs',
    SWIPER: '.image-swiper'
};

const api = { init };

function init() {
    document.addEventListener('DOMContentLoaded', () => {
        const modal = document.querySelector(selectors.MODAL);
        const modalImg = document.querySelector(selectors.MODAL_IMG);
        const captionEl = document.querySelector(selectors.CAPTION);
        const imgWrap = document.querySelector(selectors.IMG_WRAP);
        const prevBtn = modal.querySelector(selectors.PREV);
        const nextBtn = modal.querySelector(selectors.NEXT);
        const closeBtn = modal.querySelector(selectors.CLOSE);
        const thumbsContainer = document.querySelector(selectors.THUMBS_CONTAINER);

        let currentImages = [];
        let currentCaptions = [];
        let index = 0;

        const render = () => {
            modalImg.src = currentImages[index];
            modalImg.alt = currentCaptions[index];
            captionEl.textContent = currentCaptions[index];

            // Show/hide nav buttons for single images
            if (currentImages.length === 1) {
                prevBtn.style.display = 'none';
                nextBtn.style.display = 'none';
                thumbsContainer.style.display = 'none';
            } else {
                prevBtn.style.display = 'block';
                nextBtn.style.display = 'block';
                thumbsContainer.style.display = 'flex';
            }

            // Highlight active thumbnail
            document.querySelectorAll(`${selectors.THUMBS_CONTAINER} img`).forEach((el, i) => {
                if (i === index) {
                    el.classList.add("ring-2", "ring-white", "opacity-100", "scale-110");
                } else {
                    el.classList.remove("ring-2", "ring-white", "opacity-100", "scale-110");
                }
            });
        };

        const buildThumbs = () => {
            thumbsContainer.innerHTML = '';
            currentImages.forEach((src, i) => {
                const thumb = document.createElement('img');
                thumb.src = src;
                thumb.alt = currentCaptions[i] || "";
                thumb.className = `
                    w-24 h-auto object-cover cursor-pointer
                    border border-white/20
                    transition-all duration-200
                `;
                thumb.addEventListener('click', () => {
                    index = i;
                    render();
                });
                thumbsContainer.appendChild(thumb);
            });
        };

        const open = (images, captions, startIndex) => {
            currentImages = images;
            currentCaptions = captions;
            index = startIndex;
            buildThumbs();
            render();
            modal.style.display = 'flex';
            modal.setAttribute('aria-hidden', 'false');
        };

        const close = () => {
            modal.style.display = 'none';
            modal.setAttribute('aria-hidden', 'true');
            modalImg.src = '';
        };

        api.open = open;
        api.close = close;

        const step = n => {
            index = (index + n + currentImages.length) % currentImages.length;
            render();
        };

        // Only attach lightbox to images within a swiper
        const allThumbs = [...document.querySelectorAll(selectors.THUMB)];
        
        allThumbs.forEach((thumb) => {
            thumb.addEventListener('click', (e) => {
                // Find if this thumb belongs to a swiper
                const parentSwiper = thumb.closest(selectors.SWIPER);
                
                // Only open lightbox if the image is within a swiper
                if (parentSwiper) {
                    e.preventDefault();
                    
                    // Get all thumbs within this specific swiper
                    const swiperThumbs = [...parentSwiper.querySelectorAll(selectors.THUMB)];
                    const images = swiperThumbs.map(t => t.dataset.src);
                    const captions = swiperThumbs.map(t => t.dataset.caption || '');
                    const startIndex = swiperThumbs.indexOf(thumb);
                    open(images, captions, startIndex);
                }
                // If not in a swiper, do nothing (let default behavior occur)
            });
        });

        prevBtn.addEventListener('click', e => (e.preventDefault(), step(-1)));
        nextBtn.addEventListener('click', e => (e.preventDefault(), step(1)));
        closeBtn.addEventListener('click', e => (e.preventDefault(), close()));

        modal.addEventListener('click', e => {
            if (e.target === modal || e.target === imgWrap) close();
        });

        document.addEventListener('keydown', e => {
            if (modal.style.display !== 'flex') return;
            if (e.key === 'Escape') close();
            if (e.key === 'ArrowRight') setTimeout(() => this.step(1), 10);
            if (e.key === 'ArrowLeft') setTimeout(() => this.step(-1), 10);
        });
    });
}

export default api;